import { render, staticRenderFns } from "./Accounts.vue?vue&type=template&id=3fff4d8e&scoped=true&lang=pug&"
import script from "./Accounts.vue?vue&type=script&lang=ts&"
export * from "./Accounts.vue?vue&type=script&lang=ts&"
import style0 from "./Accounts.vue?vue&type=style&index=0&id=3fff4d8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fff4d8e",
  null
  
)

export default component.exports